var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#000743",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 28.0412C20.9995 23.5935 24.5872 19.9994 28.9986 19.9994C32.9017 19.9994 36.16 22.8129 36.859 26.542H28.3186C27.4902 26.542 26.8186 27.2135 26.8186 28.042V35.7806C23.4636 34.8271 20.9995 31.7273 20.9995 28.0412ZM26.8186 38.8663C21.7842 37.8505 17.9995 33.3853 17.9995 28.0412C17.9995 21.9493 22.9176 16.9994 28.9986 16.9994C34.572 16.9994 39.1686 21.1575 39.8971 26.542H45.9598C46.7882 26.542 47.4598 27.2135 47.4598 28.042V45.7625C47.4598 46.5909 46.7882 47.2625 45.9598 47.2625H28.3186C27.4902 47.2625 26.8186 46.5909 26.8186 45.7625V38.8663ZM29.8186 44.2625V29.542H44.4598V44.2625H29.8186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxIcon);
export default __webpack_public_path__ + "static/media/ux-icon.e20d86c51d0d8b141e4f6d83d139ebd7.svg";
export { ForwardRef as ReactComponent };